import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { lazy } from 'react';

// * hợp đồng lô
const ContractManagementLotAdd = lazy(() =>
    import('features/contract/contract-management-lot/pages/ContractManagementLotAdd')
);
const ContractManagementLotEdit = lazy(() =>
    import('features/contract/contract-management-lot/pages/ContractManagementLotEdit')
);
const ContractManagementLotGroup = lazy(() =>
    import('features/contract/contract-management-lot/pages/ContractManagementLotGroup')
);

const ContractManagementLotPosition = lazy(() =>
    import('features/contract/contract-management-lot/pages/pdf-contract/ContractManagementLotPosition')
);
const ContractManagementLotViewEnd = lazy(() =>
    import('features/contract/contract-management-lot/pages/contract-view/ContractManagementLotViewEnd')
);
const ContractManagementLotView = lazy(() =>
    import('features/contract/contract-management-lot/pages/contract-view/ContractManagementLotView')
);

const ContractLotRouter = [
    // * hợp đồng lô
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.LOT}`,
        exact: true,
        component: ContractManagementLotAdd,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.LOT}/:uuid`,
        exact: true,
        component: ContractManagementLotEdit,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.LOT}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractManagementLotGroup,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.LOT}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractManagementLotGroup,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.LOT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractManagementLotPosition,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.LOT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractManagementLotPosition,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.ADD}${routerPathMain.LOT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractManagementLotViewEnd,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.EDIT}${routerPathMain.LOT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractManagementLotViewEnd,
    },
    {
        path: `${routerMain.CONTRACT}${routerPathMain.VIEW}${routerPathMain.LOT}/:uuid`,
        exact: true,
        component: ContractManagementLotView,
    },
];
export default ContractLotRouter;

